import api from "./api";

/**
 * Stok uçları (backend: /api/inventory). Yanıtlar ApiResponse zarfında
 * (res.data.data); ürün listesi Spring Pageable döner. Tüm uçlar MANAGER'a özel.
 */
export const inventoryService = {
  // Ürün
  list: (params = {}) => api.get("/inventory/products", { params }),
  get: (id) => api.get(`/inventory/products/${id}`),
  create: (payload) => api.post("/inventory/products", payload),
  update: (id, payload) => api.put(`/inventory/products/${id}`, payload),
  remove: (id) => api.delete(`/inventory/products/${id}`), // soft delete (pasife al)
  hardRemove: (id) => api.delete(`/inventory/products/${id}`, { params: { hard: true } }),
  setActive: (id, active) =>
    api.patch(`/inventory/products/${id}/status`, null, { params: { active } }),

  // Stok hareketi
  listMovements: (id) => api.get(`/inventory/products/${id}/movements`),
  addMovement: (id, payload) => api.post(`/inventory/products/${id}/movements`, payload),

  // Raporlar (params: { from, to } — ISO tarih)
  salesPerformance: (params) => api.get("/inventory/reports/sales-performance", { params }),
  serviceConsumption: (params) => api.get("/inventory/reports/service-consumption", { params }),
  stockCost: (params) => api.get("/inventory/reports/stock-cost", { params }),
};
